const API_KEY = 'AH006KI085EN6Y1X'
const BASE_URL = `https://www.alphavantage.co/query?`
export {
    API_KEY,
    BASE_URL
}